<div class="basicrow">
    <div class="basicrow txt-center paytcline">
        <div class="overallpadded-c tabformdef">
            <div class="basicrow cardtypescont-m">
                <div class="basicrow">
                    <span *ngIf="this.changeVisa">
                        <img width="100%" [ngClass]="{'on': this.changeVisa, '': !this.changeVisa}" class="paytypecard " id="visa" src="/assets/images/visa_on.png">
                    </span>
                    <span *ngIf="!this.changeVisa">
                        <img width="100%" [ngClass]="{'on': this.changeVisa, '': !this.changeVisa}" class="paytypecard " id="visa" src="/assets/images/visa_off.png">
                    </span>

                    <span *ngIf="this.changeAmerican">
                        <img width="100%" [ngClass]="{'on': this.changeAmerican, '': !this.changeAmerican}" class="paytypecard " id="American" src="/assets/images/american_on.png">
                    </span>
                    <span *ngIf="!this.changeAmerican">
                        <img width="100%" [ngClass]="{'on': this.changeAmerican, '': !this.changeAmerican}" class="paytypecard " id="American" src="/assets/images/american_off.png">
                    </span>
                    <span *ngIf="this.changeMC">
                        <img width="100%" [ngClass]="{'on': this.changeMC, '': !this.changeMC}" class="paytypecard " id="MC" src="/assets/images/mastercard_on.png">
                    </span>
                    <span *ngIf="!this.changeMC">
                        <img width="100%" [ngClass]="{'on': this.changeMC, '': !this.changeMC}" class="paytypecard " id="MC" src="/assets/images/mastercard_off.png">
                    </span>
                    <!-- <img width="100%" class="paytypecard " id="visa"
                        [ngClass]="{'on': this.changeVisa, '': !this.changeVisa}"
                        src="/assets/images/typecardimg01.png"> -->

                    <!-- <img width="100%" class="paytypecard " id="American"
                        [ngClass]="{'on': this.changeAmerican, '': !this.changeAmerican}"
                        src="/assets/images/typecardimg02.png"> -->

                    <!-- <img width="100%" class="paytypecard " id="MC"
                        [ngClass]="{'on': this.changeMC, '': !this.changeMC }" src="./assets/images/typecardimg03.png"> -->
                </div>
                <div class="form-pay-container">
                    <form [formGroup]="signupFormPay">
                        <div class="grid-form-container">
                            <div class="grid-form-up">
                                <div class="grid-form">
                                    <div class="grid-title">
                                        Titular&#42;:
                                    </div>
                                    <div class="grid-field w-name">
                                        <div class="subfield">
                                            <input required formControlName="name" type="text" class="tabforminp-def-i"
                                                placeholder="Card Holder">
                                            <div [hidden]="signupFormPay.controls.name.value || signupFormPay.controls.name.untouched"
                                                class="alert alert-danger relative-pos">
                                                Nombre Requerido
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid-form">
                                    <div class="grid-title">
                                        Fecha de expiraci&oacute;n&#42;:
                                    </div>
                                    <div style="width: fit-content !important" class="grid-field">
                                        <div class="subfield">
                                            <input [appOnlyAmount] required formControlName="month" maxlength="2"
                                                type="text" class="tabforminp-datedef" placeholder="MM">

                                            <div [hidden]="signupFormPay.controls.month.value || signupFormPay.controls.month.untouched"
                                                class="alert alert-danger relative-pos ">
                                                Mes Requerido
                                            </div>
                                        </div>
                                        <div class="f-big">
                                            &#47;
                                        </div>
                                        <div class="subfield">
                                            <input [appExpirationYear] required formControlName="year" maxlength="2"
                                                type="text" class="tabforminp-datedef" placeholder="YY">

                                            <div [hidden]="signupFormPay.controls.year.value || signupFormPay.controls.year.untouched"
                                                class="alert alert-danger relative-pos ">
                                                Año Requerido
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-form-up">
                                <div>
                                    <div class="grid-form">
                                        <div class="grid-title">
                                            N&uacute;mero de tarjeta&#42;:
                                        </div>
                                        <div class="grid-field w-num">
                                            <div class="subfield">
                                                <input [appCreditCard] [source]="'payment'"
                                                    (cardType)="validationCard($event)" required
                                                    formControlName="numberCard" maxlength="16" type="text"
                                                    class="tabforminp-def-i" placeholder="Card Number">
                                                <div [hidden]="signupFormPay.controls.numberCard.value || signupFormPay.controls.numberCard.untouched"
                                                    class="alert alert-danger">
                                                    Tarjeta Requerida
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div class="grid-postal-cvv">
                                    <div class="grid-form">
                                        <div class="grid-title">
                                            C&oacute;digo postal&#42;:
                                        </div>
                                        <div class="grid-field">
                                            <div class="subfield">
                                                <input [appZipCode] required (length)="ValidationZipCode($event)"
                                                    formControlName="zipCode" minlength="5" [maxlength]="this.maxZip"
                                                    type="text" class="tabforminp-def-ii w-postal">
                                                <div [hidden]="signupFormPay.controls.zipCode.value || signupFormPay.controls.zipCode.untouched"
                                                    class="alert alert-danger w-postal">
                                                    Codigó Postal Requerido
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid-form">
                                        <div class="grid-title">
                                            CVV&#42;:
                                        </div>
                                        <div class="grid-field">
                                            <div class="subfield">
                                                <input [appOnlyNumber] [maxlength]="this.maxCvv" required
                                                    formControlName="cvv" type="text" class="tabforminp-def-ii  w-postal">
                                                <div [hidden]="signupFormPay.controls.cvv.value || signupFormPay.controls.cvv.untouched"
                                                    class="alert alert-danger w-postal">
                                                    CVV Requerido
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="basicrow tabform-m txt-center">
                    <div class="btn-continue">
                        <div class="btntxt din-b center-items" (click)="validationPayment();">
                            CONTINUAR
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>